import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-esita-modal',
  templateUrl: './esita-modal.component.html',
  styleUrls: ['./esita-modal.component.css']
})
export class EsitaModalComponent implements OnInit {

  @Input() invoiceId: string = '';
  @Input() userId: string = '';

  motivoEsito : string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private invoicesService: InvoicesService,
    private toast : ToastService
  ) { }

  ngOnInit(): void {
  }

  close(){
    this.activeModal.close(false);
  }

  esitaFattura(val: number) {
    let data = {
      'messaggio' : this.motivoEsito
    };
    if (val == 1) {
      //console.log(this.invoiceId + " Accetta!" + this.userId);
      this.invoicesService.accettaFattura(this.userId, this.invoiceId, data).then(
        (res) => {
          if (res.success) {
            this.toast.openToast(res.msg, "success");
            this.activeModal.close(false);
          } else {
            this.toast.openToast(res.msg, "error");
            this.activeModal.close(false);
          }
        }
      )
    } else {
      //console.log(this.motivoEsito + " Rifiuta!");
      this.invoicesService.rifiutaFattura(this.userId, this.invoiceId, data).then(
        (res) => {
          if (res.success) {
            this.toast.openToast(res.msg, "success");
            this.activeModal.close(false);
          } else {
            this.toast.openToast(res.msg, "error");
            this.activeModal.close(false);
          }
        }
      );
    }
  }

}
